
import React, { useEffect, useState, useContext } from 'react';
import { StepFourFooterRightSide } from './styles';
import { useHistory } from 'react-router';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { getActivities } from '../../../services/actividades';
import { getSimulacionEdades } from '../../../services/simulation';
import { calculateDate } from '../../../helpers/date';
import { SimulatorContext } from '../../../store/';
import { default as SimulatorTypes } from '../../../store/Simulator/types';
import Select from '../../../components/Select';
import InputDefault from '../../../components/InputDefault';
import InputDate from '../../../components/InputDate';
import InputPhone from '../../../components/InputPhone';
import RadioButtonForm from '../../../components/RadioButtonForm';
import CheckBox from '../../../components/CheckBox';
import { identificationType, simulatorSteps, contactMeans, creditLinesBack } from '../../../helpers/enum';
import { handleChangeIdentification } from '../../../helpers/price';
import { DefaultLargeButton, SecondaryLargeButton, TertiaryLargeButton, DefaultSmallButton } from '../../../components/Buttons/styles';
import { saveSimulationResult } from '../../../services/simulation';

import FormTemplate from '../../../components/FormTemplate';
import { Form, FormFooter, FormRow, FormRowInvisible } from '../../../components/FormTemplate/styles';
import Loader from '../../../components/Loader';
import ModalInfo from '../../../components/ModalInfo';
import ModalActionSendIdValidation from '../../../components/ModalActionSendIdValidation';
import colors from '../../../assets/styles/colors';
import { BsExclamation, BsCheck } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';
import { getClientDataFull } from '../../../services/clients';
import { getLastCreditByClient } from '../../../services/credit';
import { postRiskLevelSoyYo } from '../../../services/soyYo';

const OldClientDataPage = ({ setActiveStep, setLastStep, setDeskError, setShowModal }) => {
  const history = useHistory();
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const location = useLocation();
  const { simulator, setSimulator } = useContext(SimulatorContext);
  const { register, handleSubmit, watch, setValue, control, clearErrors, errors } = useForm({ defaultValues: simulator.clientData });
  const fields = watch();
  const [paymentBill, setPaymentBill] = useState([]);
  const [activities, setActivities] = useState([]);
  const [showActivity, setShowActivity] = useState(false);
  const [showContactMean, setShowContactMean] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showModalInfoEdad, setShowModalInfoEdad] = useState(false);
  const [showModalInfoCapacity, setShowModalInfoCapacity] = useState(false);
  const [showModalIdValidation, setShowModalIdValidation] = useState(false);
  const [permission, setPermission] = useState(false);
  const [minAgeAllowed, setminAgeAllowed] = useState(0);
  const [maxAgeAllowed, setmaxAgeAllowed] = useState(0);
  const [idCurrentSimulation, setIdCurrentSimulation] = useState('');
  const [showModalSoyYo, setShowModalSoyYo] = useState(false);
  const [descriptionModalSoyYo, setDescriptionModalSoyYo] = useState('');
  const emailValue = useWatch({ control, name: 'email' })

  async function initializedStateComponent() {
    try {
      setSimulator({
        type: SimulatorTypes.SET_IDENTIFICATION_TYPE,
        tipoIdentificacion: 'CC'
      })

      if (simulator.clientData.pagaduria) {
        setValue("pagaduria", simulator.clientData.pagaduria.nombre);
      }

      if (simulator.clientData.departamento) {
        setValue("departamento", simulator.clientData.departamento.id);
      }

      const activities = await getActivities();

      const ages = await getSimulacionEdades();
      setminAgeAllowed(ages.min);
      setmaxAgeAllowed(ages.max);

      if (location.idSimulation) {
        if (simulator.clientData.actividadCliente && !simulator.clientData.actividadCliente.id) {
          const actividad = activities.data.find(item => item.id === simulator.clientData.actividadCliente);
          setSelectedActivitie(actividad);
        }

        handleCalculateDate();
      }

      setPaymentBill(paymentBill.data);
      setActivities(activities.data);
    } catch (error) {
      console.log(error.response)
    }
  }


  function initSolicitation() {
    initSimulation();
  }
  const onChangeEmail = (e) => {
    const lowercaseEmail = e.target.value.toLowerCase();
    setValue('email', lowercaseEmail);
  };

  useEffect(() => {
    const lowercaseEmail = emailValue.toLowerCase();
    setValue('email', lowercaseEmail);
  }, [emailValue, setValue]);
  
  function checkCapacity() {
    return parseInt(simulator.simulation.remanenteEstimado) > 0 &&
      parseInt(simulator.simulation.montoMaximoSugerido) >= parseInt(simulator.simulation.remanenteEstimado);
  }

  function saveSimulationBody(isForSolicitation) {
    const req = {
      idSimulacion: history.location.idSimulation,
      idPagaduria: simulator.clientData.pagaduria.id,
      idAsesor: session.idAsesor,
      idOficina: simulator.desk.id,
      idLineaCredito: simulator.financesData.lineaCredito.idBackend,
      subCanal: 'WEB',
      actividadCliente: simulator.clientData.actividadCliente.id,
      tasa: parseFloat(simulator.priceValueToSolicitate.tasa.id),
      plazo: parseInt(simulator.priceValueToSolicitate.plazo),
      monto: parseInt(simulator.priceValueToSolicitate.monto),
      diasInteresesIniciales: parseInt(simulator.priceValueToSolicitate.diasInteresesIniciales),
      ingresos: parseInt(simulator.financesData.ingresos),
      descuentosLey: (simulator.financesData.descuentosLey) ? parseInt(simulator.financesData.descuentosLey) : 0,
      descuentosNomina: (simulator.financesData.descuentosNomina) ? parseInt(simulator.financesData.descuentosNomina) : 0,
      //destinoCredito: simulator.financesData.destinoCredito.id,
      medioContacto: simulator.clientData.medioContacto.id,
      carteras: simulator.simulation.carteras,
      cliente: {
        primerNombre: fields.primerNombre,
        segundoNombre: fields.segundoNombre,
        primerApellido: fields.primerApellido,
        segundoApellido: fields.segundoApellido,
        nombres: fields.nombres,
        tipoIdentificacion: simulator.clientData.tipoIdentificacion,
        identificacion: parseInt(fields.identificacion.replaceAll(".", "")),
        fechaNacimiento: fields.fechaNacimiento ? fields.fechaNacimiento : simulator.clientData.fechaNacimiento,
        celular: fields.celular.replaceAll(" ", ""),
        email: fields.email,
        idCiudad: simulator.clientData.ciudad.id,
        departamento: simulator.clientData.departamento.id
      },
      departamento: simulator.clientData.departamento.id,
      ciudad: simulator.clientData.ciudad,
      validarIdentidad: isForSolicitation,
      genero: simulator.clientData.genero,
      totalActivos: simulator.priceValueToSolicitate.totalActivos,
      estrato: simulator.clientData.estrato?.nombre,
      productPricing: simulator.priceValueToSolicitate.pricingProduct,
      nivelEducativo: simulator.priceValueToSolicitate.nivelEscolaridad?.idLegado,
      tipoContrato: simulator.priceValueToSolicitate.tipoContrato?.nombre

    }

    if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id || simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
      req.idCreditoPadre = getListofCredits().map(credito => credito.id)
    }

    return req;
  }

  function getListofCredits() {
    return (simulator.financesData.credits.length === undefined) ? [simulator.financesData.credits] : simulator.financesData.credits;
  }

  async function saveSimulation() {
    try {
      setIsLoading(true);
      const req = saveSimulationBody(false);
      const response = await saveSimulationResult(req);
      setIdCurrentSimulation(response.data.idSimulacion);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }
  async function initSimulation() {
    try {
      setIsLoading(true);
      const req = saveSimulationBody(true);
      const response = await saveSimulationResult(req);
      setIsLoading(false);

      let dataa = {
        documentType: "CC",
        identificationNumber: fields.identificacion.replaceAll(".", ""),
        data: {
          country_code: "+57",
          phone: fields.celular.replaceAll(" ", ""),
          email_address: fields.email,
          name: fields.primerNombre,
          lastname: fields.primerApellido
        }
      }
      setIsLoading(true);
      const responseSoyYo = await postRiskLevelSoyYo(dataa)
      setIsLoading(false);
      if(responseSoyYo.data){
        setDescriptionModalSoyYo(<><div>En la validación de la información de contacto registrada para el trámite de crédito del cliente <b>{fields.primerNombre} {fields.primerApellido}</b>  hemos identificado diferencias. </div>
          <br></br>
          <div>Ahora mismo, podrás continuar con el proceso de perfilamiento y simulación. Sin embargo, para poder evaluar la solicitud de crédito es indispensable que el cliente se acerque a una de nuestras oficinas para realizar el  proceso de autenticación biométrico y registro de datos de contacto.</div>
          <br></br>
          <div>Te agradecemos brindar acompañamiento al cliente en este proceso.</div>
        </>)
        //setShowModalSoyYo(true)
      }


      await setIdCurrentSimulation(response.data.idSimulacion);
      setShowModalIdValidation(true);
    } catch (error) {
      console.log(error)
      setIsLoading(false);
      console.log(error.response)
    }
  }

  function moveToDashboard() {
    history.push({
      pathname: '/admin/dashboard/'
    });
  }

  function setIdentificationRadioChecked(radio) {
    setSimulator({
      type: SimulatorTypes.SET_IDENTIFICATION_TYPE,
      tipoIdentificacion: radio.value,
      identificacion: ''
    })
    setValue('identificacion', '');
  }

  function setCompleteStep(data) {
    data.tipoIdentificacion = simulator.clientData.tipoIdentificacion;
    data.actividadCliente = fields.actividadCliente;
    data.edad = fields.edad;
    data.pagaduria = fields.pagaduria;
    data.medioContacto = fields.medioContacto;
    data.desk = simulator.desk;

    if (simulator.desk !== '') {
      setDeskError({});
      setSimulator({
        type: SimulatorTypes.SET_CLIENT_DATA,
        clientData: data
      });
    } else {
      setIsLoading(false);
      setDeskError({ required: true, message: 'Este dato es obligatorio' });
      return;
    }

    if (fields.edad < minAgeAllowed || fields.edad > maxAgeAllowed) {
      setShowModalInfoEdad(true);
      return;
    }
    //mandar mail
    //terminar pasos


    setActiveStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE);
    setLastStep(simulatorSteps.CLIENT_DATA);
  }

  function setBackStep() {
    setActiveStep(simulatorSteps.RESULT);
  }

  function handleCalculateDate() {
    let years = calculateDate(fields.fechaNacimiento);
    setValue("edad", years);

    setSimulator({
      type: SimulatorTypes.SET_YEARS_OLD_BY_DATE,
      edad: years
    })
  }

  function toUpperFirst(str) {
    return str == '' || str == null ? str :
      str[0].toUpperCase() + (str.length > 1 ? str.substring(1).toLowerCase() : '');
  }

  function setSelectedActivitie(activitie) {
    setValue("actividadCliente", activitie);
    clearErrors("actividadCliente", {});

    setSimulator({
      type: SimulatorTypes.SET_ACTIVITIE,
      actividadCliente: activitie
    })
  }

  function setContactMean(contactMean) {
    setValue("medioContacto", contactMean);
    clearErrors("medioContacto", {});

    setSimulator({
      type: SimulatorTypes.SET_CONTACT_MEAN,
      medioContacto: contactMean
    })
  }


  function onChangeIdentification(e) {
    var identificacion = undefined;
    if (simulator.clientData.tipoIdentificacion === 'CE') {
      identificacion = e.target.value;
    } else {
      identificacion = handleChangeIdentification(e.target.value);
    }
    setValue('identificacion', identificacion);
  }

  async function onChangePermission(e) {
    await setPermission(!permission);
  }

  useEffect(() => {
    setIsLoading(true);
    initializedStateComponent();
    setIsLoading(false);


    return () => {
      setPaymentBill([]);
      setActivities([]);
    }
  }, []);

  function moveToDashboard() {
    history.push({
      pathname: '/admin/identity-validation/',
      idSimulation: simulator
    });
  }

  return (
    <FormTemplate
      idForm="client-data-step-lage"
      idButton="new-simulation"
      labelButton="Nueva simulación"
      activeStep="3/3"
      stepLabel="Datos cliente"
      actionHeaderButton={setShowModal}>
      <FormRow>
        <RadioButtonForm
          label="Tipo de documento"
          setIdentificationRadioChecked={setIdentificationRadioChecked}
          selected={simulator.clientData.tipoIdentificacion}
          name="tipoIdentificacion"
          id="tipoIdentificacion"
          radios={[
            { label: 'CC', value: 'CC' }
          ]} />
      </FormRow>
      <FormRow col="2">
        <Controller
          name="identificacion"
          control={control}
          value={simulator.clientData.identificacion}
          render={() => (
            <InputDefault
              name="identificacion"
              label="Número de documento de identidad"
              register={register({
                required: "Este dato es obligatorio",
                pattern: {
                  value: /^\d+(\.\d+)*$/,
                  message: "Error en el número, ingresa uno válido",
                }
              })}
              id="identificacion"
              error={errors.identificacion}
              maxLength={simulator.clientData.tipoIdentificacion === 'CE' ? identificationType.ce.max : identificationType.cc.max}
              minLength={simulator.clientData.tipoIdentificacion === 'CE' ? identificationType.ce.min : identificationType.ce.min}
              onChange={onChangeIdentification}
            />
          )}
        />
      </FormRow>
      <Form onSubmit={handleSubmit(setCompleteStep)} id="form">
        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="Primer Nombre"
            name="primerNombre"
            register={register({ required: "Este dato es obligatorio" })}
            id="primerNombre"
            error={errors.primerNombre}
            value={simulator.clientData.primerNombre} />
          <Controller
            as={InputDefault}
            control={control}
            label="Segundo Nombre"
            name="segundoNombre"
            register={register}
            id="segundoNombre"
            value={simulator.clientData.segundoNombre} />
        </FormRow>
        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="Primer Apellido"
            name="primerApellido"
            register={register({ required: "Este dato es obligatorio" })}
            id="primerApellido"
            error={errors.primerApellido}
            value={simulator.clientData.primerApellido} />
          <Controller
            as={InputDefault}
            control={control}
            label="Segundo Apellido"
            name="segundoApellido"
            register={register}
            id="segundoApellido"
            value={simulator.clientData.segundoApellido} />
        </FormRow>
        {!simulator.pricing &&
          <FormRow col="2">
            <InputDate
              aria-required
              type="date"
              label="Fecha de nacimiento"
              name="fechaNacimiento"
              register={register({ required: "Este dato es obligatorio" })}
              id="fechaNacimiento"
              onBlur={handleCalculateDate}
              error={errors.fechaNacimiento} />
            <Controller
              as={InputDefault}
              control={control}
              label="Edad cliente"
              name="edad"
              register={register}
              id="yearsold"
              error={errors.edad}
              readOnly={true}
              value={simulator.clientData.edad} />
          </FormRow>}

        <FormRow col="2">
          <Controller
            as={InputPhone}
            control={control}
            label="Celular"
            name="celular"
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /^(?:30|31|32|33|34|35)([0-9]{1}) ([0-9]{3}) ([0-9]{2}) ([0-9]{2})$/,
                message: "Error en el número, ingresa uno válido",
              },
            })}
            id="celular"
            error={errors.celular}
            mask="999 999 99 99"
            value={simulator.clientData.celular} />

          <Controller
            as={InputDefault}
            control={control}
            label="Correo Electrónico"
            name="email"
            onChange={onChangeEmail}
            register={register({
              required: "Este dato es obligatorio",
              pattern: {
                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "El correo electrónico tiene un formato inválido",
              },
            })}
            id="email"
            error={errors.email}
            value={simulator.clientData.email} />
        </FormRow>
        { !simulator.pricing &&
          <FormRow col="2">
            <Select
              error={errors.actividadCliente}
              setShow={setShowActivity}
              show={showActivity}
              defaultValue={simulator.clientData.actividadCliente?.nombre}
              setSelected={setSelectedActivitie}
              list={activities}
              placeholder="Seleccionar..."
              label="Actividad"
              name="actividadCliente"
              id="actividadCliente"
              register={register({ required: "Este dato es obligatorio" })} />
          </FormRow>

        }

        <FormRow col="2">
          <Select
            error={errors.medioContacto}
            show={showContactMean}
            setShow={setShowContactMean}
            defaultValue={simulator.clientData.medioContacto?.nombre}
            setSelected={setContactMean}
            list={contactMeans}
            placeholder="Seleccionar..."
            label="¿Cómo se enteró de ExcelCredit?"
            name="medioContacto"
            id="medioContacto"
            register={register({ required: "Este dato es obligatorio" })} />

        </FormRow>
        <FormRow col="1">
          <CheckBox
            error={errors.permisos}
            defaultValue={false}
            label={<div>Estimado (a) cliente, vamos a iniciar el proceso de simulación, para esto vamos a recopilar unos datos personales que serán cargados en nuestra aplicación. Estos datos serán tratados bajo nuestra política de protección de datos personales y la autorización que me dé ahora verbalmente, será ratificada en un documento firmado electrónicamente en unos pasos siguientes. ¿Está usted de acuerdo? <br/><br/>ADICIONALMENTE, DADO QUE ESTE ES UN PROCESO DIGITAL, ES NECESARIO ENVIARLE INFORMACIÓN A TRAVÉS DE SU TELÉFONO CELULAR, MENSAJES DE WHATSAPP, MENSAJES DE TEXTO Y SU CORREO ELECTRÓNICO. USTED AUTORIZA A LA SOCIEDAD PARA QUE MEDIANTE ESTOS CANALES PUEDA CONTACTARLO Y ENVIARLE PUBLICIDAD COMERCIAL Y CUALQUIER OTRO TIPO DE INFORMACIÓN REFERENTE A LOS PRODUCTOS Y SERVICIOS OFRECIDOS, EN CUMPLIMIENTO A LO ESTABLECIDO EN LA LEY 2300 DE 2023?</div>}
            name="permiso"
            id="permiso"
            checked={permission}
            onChange={onChangePermission}
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow>
        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" onClick={() => setBackStep()} id="back-step">Volver</DefaultLargeButton>

          <StepFourFooterRightSide>
            <TertiaryLargeButton type="button" disabled={!permission} onClick={() => initSolicitation()} id="init-solicitation">Iniciar solicitud</TertiaryLargeButton>
            <SecondaryLargeButton type="button" onClick={() => saveSimulation()} id="save-simulation" disabled={!checkCapacity()}>Guardar simulación</SecondaryLargeButton>
          </StepFourFooterRightSide>
        </FormFooter>
      </Form>
      {isLoading && <Loader />}
      <ModalInfo
        open={showModalInfoEdad}
        setShowModal={setShowModalInfoEdad}
        title="El cliente debe tener entre 20 y 84 años."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoCapacity}
        setShowModal={setShowModalInfoCapacity}
        title="Cliente sin capacidad"
        description="Monto solicitado supera la capacidad del cliente."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalActionSendIdValidation
        open={showModalIdValidation}
        actionFunctionDownButton={() => moveToDashboard()}
        title={"Validación de Identidad"}
        actionLabelFunctionDownButton="Continuar"
        description={"Se le ha enviado un correo electrónico al cliente para la validación de su identidad. Hasta que pueda retomar la solicitud, ésta se encontrará en el apartado “Mis solicitudes - Pendientes por radicar”."}
        bodyIcon={<BsCheck id="message" size={32} color={colors.white} />}
        backgroundIcon={colors.textHyperlink} />
      <ModalInfo
        open={showModalSoyYo}
        setShowModal={setShowModalSoyYo}
        title="¡Apreciado Aliado Comercial!"
        description= {descriptionModalSoyYo}
        backgroundIcon={colors.yellow}
        bodyIcon={<BsCheck size={32} color={colors.white} id="exclamation-icon" />} />
    </FormTemplate>
  )
}

export default OldClientDataPage
